export default __webpack_public_path__ + "static/media/70.093d13fb.jpg";